import Cookies from 'js-cookie'

const TokenKey = 'Admin-Token'
const NameKey = 'Admin-Name'
const IdKey = 'Admin-Id'
const PermsKey = 'Admin-Perms'
const DeptNameKey = "Admin-DeptNameKey"
const DeptLevelKey = "Admin-DeptLevelKey"

export function getToken() {
  return Cookies.get(TokenKey)
}

export function setToken(token) {
  localStorage.setItem(TokenKey, token)
  return Cookies.set(TokenKey, token)
}

export function removeToken() {
  localStorage.removeItem(TokenKey)
  return Cookies.remove(TokenKey)
}

export function getName() {
  return Cookies.get(NameKey)
}

export function setName(name) {
  return Cookies.set(NameKey, name)
}

export function removeName() {
  return Cookies.remove(NameKey)
}

export function getId() {
  return Cookies.get(IdKey)
}

export function setId(id) {
  return Cookies.set(IdKey, id)
}

export function removeId() {
  return Cookies.remove(IdKey)
}

export function getPerms() {
  return Cookies.get(PermsKey)
}

export function setPerms(id) {
  return Cookies.set(PermsKey, id)
}

export function removePerms() {
  return Cookies.remove(PermsKey)
}

export function getDeptName() {
  return Cookies.get(DeptNameKey)
}

export function setDeptName(deptName) {
  return Cookies.set(DeptNameKey, deptName)
}

export function removeDeptName() {
  return Cookies.remove(DeptNameKey)
}

export function getDeptLevel() {
  return Cookies.get(DeptLevelKey)
}

export function setDeptLevel(deptLevel) {
  return Cookies.set(DeptLevelKey, deptLevel)
}

export function removeDeptLevel() {
  return Cookies.remove(DeptLevelKey)
}
